import {useQuery} from 'react-query';
import {useNavigate} from 'react-router-dom';
import {AxiosResponse} from 'axios/index';
import {generateQueryKey} from "../../../../constants/hookConstants";
import {ApiError, ApiResponse} from "../../../../interfaces/apiResponse.type";
import {CORE_API_SUFFIX, dataFetch} from "../../../../axios/customAxios";

export const useGetIntegrations = (
    identifier: string,
) => {
    const queryParams = new URLSearchParams();

    const queryKey = generateQueryKey(identifier, queryParams);

    return useQuery<AxiosResponse, ApiError<null>, ApiResponse<any>>(
        [`integrations_name_${queryKey}`],
        () => dataFetch.get(`${CORE_API_SUFFIX}organization-settings/integrations`),
    );
};